// @ts-strict-ignore
import {Component, OnInit} from "@angular/core";
import {interval, Subscription} from "rxjs";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {zoomInOnEnterAnimation} from "angular-animations";

export interface BatteryManager {
	charging: boolean;
	chargingTime: number;
	dischargingTime: number;
	level: number;
}

@UntilDestroy()
@Component({
	selector: "sim-battery-state",
	templateUrl: "./battery-state.component.html",
	styleUrls: ["./battery-state.component.scss"],
	animations: [zoomInOnEnterAnimation({duration: 175})],
	standalone: false,
})
export class BatteryStateComponent implements OnInit {
	public battery: BatteryManager;

	private batterySubscription: Subscription;

	constructor() {}

	ngOnInit(): void {
		this.batterySubscription = interval(1000)
			.pipe(untilDestroyed(this))
			.subscribe(() => {
				this.refreshBattery();
			});
	}

	private refreshBattery() {
		const navi = <any>navigator;
		if (navi.getBattery) {
			navi.getBattery().then((battery: BatteryManager) => {
				this.battery = battery;
			});
		} else {
			console.warn("battery api not supported!");
			this.batterySubscription?.unsubscribe();
		}
	}

	public hasBattery() {
		//charging					-> true if plugged in OR no battery
		//dischargingTime infinite	-> true if plugged in OR no battery
		return this.battery && (!this.battery.charging || isFinite(this.battery?.dischargingTime) || this.battery?.level < 1);
	}

	public isCharging() {
		return this.hasBattery() && this.battery?.charging;
	}
}
